import { useTranslation } from 'next-export-i18n';
import React, { useCallback, useRef } from 'react';
import type { MapRef } from 'react-map-gl';

import SimpleCard from '@/components/cards/Card';
import VenturesMapBox from '@/components/map/VenturesMapBox';
import type CompanyProps from '@/types/Company.type';
import { getCompanyLocationMarkers } from '@/utils/mapUtils';

type LocationsProps = {
  company: CompanyProps;
};

const Locations = ({ company }: LocationsProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { specific_locations } = company;
  const mapRef = useRef<MapRef>();
  const { t } = useTranslation();
  const count = specific_locations.length;

  const markers = useCallback(() => {
    return getCompanyLocationMarkers(company);
  }, [company]);

  return (
    <SimpleCard padding="p-5">
      <h2 className="font-bold">
        {t('company.location', { plural: count > 1 ? 's' : '' })} ({count})
      </h2>
      <div className="mt-3 h-60 bg-gray-200 md:mt-7 md:h-96">
        <VenturesMapBox
          mapRef={mapRef}
          handleHideVentures={() => {}}
          markers={markers()}
          locations={specific_locations}
        />
      </div>
    </SimpleCard>
  );
};

export default Locations;
